import React from "react"
import DefaultFooter from "../footer/DefaultFooter"
import DefaultPermissions from "../permissions/DefaultPermissions"
import DefaultTitle from "../title/DefaultTitle"

function DefaultConsent({ id, rrn, ticket, consents, redirect }) {
  return (
    <>
      <DefaultTitle merchantName={ticket.tp.name} />
      <div className="container-flex">
        <DefaultPermissions
          sharedInformation={ticket.tp.sharedInformation}
          clientName={ticket.client.name}
        />
      </div>
      <DefaultFooter
        id={id}
        rrn={rrn}
        clientName={ticket.client.name}
        opt={consents}
        redirect={redirect}
      />
    </>
  )
}

export default DefaultConsent
